/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./downloadPreview.vue?vue&type=template&id=1fd6f590&scoped=true&"
import script from "./downloadPreview.vue?vue&type=script&lang=js&"
export * from "./downloadPreview.vue?vue&type=script&lang=js&"
import style0 from "./downloadPreview.vue?vue&type=style&index=0&id=1fd6f590&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd6f590",
  null
  
)

export default component.exports